export default "__VITE_ASSET__KoAYNEa3__"